import * as qs from 'qs';
import { AxiosResponse } from 'axios';

import { PaymentPartnerDto, ReportFilterProps, ServiceResult } from '@project/types';
import { authNetworkService } from '@project/services';

import paymentPartnerUrls from './payment-partners.urls';

const generateHeaders = () => {
  return {
    Accept: 'application/csv',
  };
};

const get = async (): Promise<PaymentPartnerDto[]> => {
  const url = paymentPartnerUrls.getBaseUrl();
  const response = await authNetworkService
    .get<ServiceResult<PaymentPartnerDto[]>>(url)
    .catch(Promise.reject);
  return response.data.data;
};

export const getPaymentPartnerIdOwnerReport = (
  filterProps?: ReportFilterProps,
): Promise<AxiosResponse<Blob>> => {
  const url = paymentPartnerUrls.baseContentUrl();
  const headers = generateHeaders();

  return authNetworkService.get(url, {
    responseType: 'blob',
    timeout: 0,
    headers,
    params: {
      fromDate: filterProps.fromDate,
      toDate: filterProps.toDate,
      paymentPartnerId: filterProps.partnerId,
    },
    paramsSerializer: (params) => qs.stringify(params, { allowDots: true }),
  });
};

export const getPaymentPartnerOutstandingFinesReport = (
  filterProps?: ReportFilterProps,
): Promise<AxiosResponse<Blob>> => {
  const url = paymentPartnerUrls.fineOutstandingUrl();
  const headers = generateHeaders();

  return authNetworkService.get(url, {
    responseType: 'blob',
    timeout: 0,
    headers,
    params: {
      fromDate: filterProps.fromDate,
      toDate: filterProps.toDate,
      paymentPartnerId: filterProps.partnerId,
    },
    paramsSerializer: (params) => qs.stringify(params, { allowDots: true }),
  });
};

export default {
  getPaymentPartnerOutstandingFinesReport,
  getPaymentPartnerIdOwnerReport,
  get,
};
